import { $ } from 'hanako-ts/dist/Framework';
import { Elem } from 'hanako-ts/dist/Collection/Types';
import { Collection } from 'hanako-ts/dist/Collection';
import { Component } from 'hanako-ts/dist/Component';
import { InitalLetter } from './Appearers/InitialLetters';
import { Typewriter } from './Appearers/Typewriter';
import { Pixelator } from './Appearers/Pixelator';

function isInViewport(item: Collection): boolean {
  const top = item.viewportPosition()?.y || -1;
  const bottom = top + item.height();

  return (top >= 0 && top < ($(window).height())); // || (bottom >= 0 && bottom < ($(window).height()));
}

export class PageAppear extends Component {
  private static items: Array<Collection> = [];
  private static itemsIndex: number = 0;
  private static scrollTimeout: number | null;

  constructor() {
    super('PageAppear', true);
  }

  public async init(): Promise<void> {
    await super.init();

    setTimeout(() => {
      // Logo title
      $('#site-title p').each((item: Collection) => {
        var text = $(item).text().toLowerCase().trim();

        $(item).text('');
        $(item).empty();
        for (var i = 0; i < text.length; i++) {
          $(item).append($.parseHTML('<ltr class="me-10 initial" data-appear-element data-appear-only-once>' + text[i] + '</ltr>'));
        }
      });

      // If already on site
      const alreadyIn = (sessionStorage.getItem('already-in') == 'true') ? true : false;
      if (alreadyIn) {
        $('[data-appear-only-once]').each((item: Collection) => {
          if ($(item).hasClass('initial')) {
            new InitalLetter(item, true);
          } else {
            $(item).removeAttr('data-appeareable').attr('data-appeared', '');
          }
        });

        setTimeout(function () {
          $('[data-appear-only-once]').each((item: Collection) => {
            item.removeAttr('data-appear-only-once');
          });
        }, 500);
      }

      //$('#button-toggle-menu').removeClass('d-none');

      //Sub elements
      $('[data-splitable]').each((item: Collection) => {
        item.find('h2, h3, p, li').each((child: Collection) => {
          child.attr('data-appeareable', '');
        });

        $(item).removeAttr('data-splitable');
      });

      $(window).on('scroll', () => {
        PageAppear.scanContent();

        if (!PageAppear.scrollTimeout) {
          PageAppear.scrollTimeout = window.setTimeout(() => {
            PageAppear.scrollTimeout = null;

            PageAppear.appear();
            PageAppear.itemsIndex++;
          }, 100);
        }
      });
      PageAppear.start();
    }, 100);

    this.success();
  }

  private static start(): void {
    $('[data-appeareable]').each((item: Collection) => {
      if (isInViewport(item)) item.attr('data-appear-element', '');

      $(item).removeAttr('data-appeareable');
    });

    PageAppear.scanContent();
    PageAppear.appear();

    PageAppear.itemsIndex++;

    sessionStorage.setItem('already-in', 'true');
  }

  public static scanContent(): void {
    $('[data-appear-element]').each((item: Collection) => {
      if (item.hasAttr('data-scanned') || item.hasAttr('data-appeared')) return;

      if (isInViewport(item)) {
        item.attr('data-scanned', '');

        if (!PageAppear.items[PageAppear.itemsIndex]) PageAppear.items[PageAppear.itemsIndex] = new Collection();
        PageAppear.items[PageAppear.itemsIndex].add(item.get(0));
      };
    });
  }

  public static appear(legacyItems?: Collection): void {
    var items: Collection = (!legacyItems) ? PageAppear.items[PageAppear.itemsIndex] : legacyItems;

    if (!items) return;

    var itemFound: boolean = false;
    items.each((item: Collection) => {
      if (item.hasAttr('data-appearing') || (item.hasAttr('data-appeared') || itemFound)) return;

      const tagName = item.get(0).tagName;

      if (tagName == 'IMG') {
        PageAppear.appearImageNode(items, item);
      } else if ($(item).hasClass('initial')) {
        PageAppear.appearInitialLetter(items, item);
      } else if ($(item).hasAttr('data-appear-block')) {
        PageAppear.appearBlock(items, item);
      } else {
        PageAppear.appearTextNode(items, item);
      }

      item.removeAttr('data-scanned');

      itemFound = true;
    });
  }

  private static appearInitialLetter(items: Collection, item: Collection): void {
    new InitalLetter(item, false, () => {
      PageAppear.appear(items);
    });
  }

  private static appearTextNode(items: Collection, item: Collection): void {
    new Typewriter(item, () => {
      PageAppear.appear(items);
    });
  }

  private static appearImageNode(items: Collection, item: Collection): void {
    if ($(item).hasClass('xl:none') && window.innerWidth >= 992 || $(item).hasClass('xl:block') && window.innerWidth < 992) {
      item.attr('data-appeared');

      PageAppear.appear(items);
    } else {
      const imageLoader = new Image();
      imageLoader.src = $(item).data('src');
      imageLoader.onload = () => {
        item.attr('src', item.data('src'));

        Pixelator.createPixelator(item, () => {
          PageAppear.appear(items);
        });
      };
    }
  }

  private static appearBlock(items: Collection, item: Collection): void {
    item.attr('data-appeared', '');
    item.removeAttr('data-appearing');
    item.removeAttr('data-appear-element');
    item.removeAttr('data-appear-block');

    setTimeout(() => {
      PageAppear.appear(items);
    }, 75);
  }
}
